import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';

import template from './index.jade';
import css from './index.styl?inline';

export class ListItem extends Component {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      active: `boolean`,
      disabled: `boolean`,
      static: `boolean`,
    };
  }

  get config() {
    return {
      css,
      template,
      useShadowDom: true,
    };
  }
}

export const ListItemEl = defineAndMakeJsxFactory(`mp-list-item`, ListItem);
